import Lenis from "lenis";
import "lenis/dist/lenis.css";
import Splide from "@splidejs/splide";
import '@splidejs/splide/css';
import anime from "animejs/lib/anime.es.js";
import "htmx.org";
import { accordionsFunc,mq } from "./modules/utils";
import calendarFunc from "./modules/_calendar";
// import imagesLoaded from "imagesloaded";
import GLightbox from "glightbox";
import SimpleBar from "simplebar";         // 本体
import 'simplebar/dist/simplebar.css'; // スタイル



// 後で使用するためのbody要素への参照
const BODY = document.getElementsByTagName("body");

const splideFunc = () => {
  const elem = document.querySelector(".js-splide");
  if (!elem) return;
    var splide = new Splide(elem, {
      autoplay: true,
      interval: 4000,
      type: "fade",
      speed: "1600",
      rewind: true,
      arrows: false,
      perPage: 1,
      pauseOnHover: false,
      classes: {
        // ページネーション関連のクラスを追加
        pagination: "splide__pagination kv-pagination", // container
        page: "splide__pagination__page kv-page", // each button
      },
    });
  if (!splide) return
    splide.mount();
}

const hbgFunc = () => {
  const header = document.querySelector(".header");
  const hbg = document.querySelector(".js-hbg");

  if (!hbg) return;
  if (header.classList.contains("load")) return;
  header.classList.add("load");

  // hbg内でのクリックイベントをデリゲート
  hbg.addEventListener(
    "click",
    (e) => {
      e.preventDefault();

      // BODY[0]にopenがなければ追加し、300ms後に処理を続行
      if (!BODY[0].classList.contains("open")) {
        BODY[0].classList.add("open");
        setTimeout(() => {
          runAnimationProcess(e);
        }, 300);
      } else {
        // すでにopenがある場合は即時処理
        runAnimationProcess(e);
      }
    },
    false,
  );

  function runAnimationProcess(e) {
    hbg.classList.add("operation");
    // console.log(e?.classList.contains("js-hbg"));
    // const target = e.target.closest(".js-hbg"); // サブメニューをトグルする要素のクラス
    // if (!target) {
    //   if (!e?.classList)return;
    //   if (!hbg.classList.contains("js-hbg")) return;
    //  }

    const isOpen = hbg.classList.contains("sub-menu-open");

    const uls = header.querySelectorAll("ul");

    // アニメーションを追加する関数
    const addAnimation = (timeline, animationProps, offset = 0) => {
      timeline.add(animationProps, offset);
    };

    if (mq("pc")) {
      uls.forEach((ul, index) => {
        const tl = anime.timeline({
          easing: "easeInOutCubic",
          duration: 300,
        });
        const links = ul.querySelectorAll("a");
        // 最初のアニメーションステップ
        addAnimation(tl, {
          targets: links,
          translateY: "10px",
          opacity: 0,
          easing: "easeInOutCubic",
          duration: 400,
          delay: (el, i) => -30 + 30 * i,
          complete: () => {
            if (index === 0) {
              if (header.classList.contains("open")) {
                hbg.classList.toggle("sub-menu-open");
              } else {
                hbg.classList.toggle("sub-menu-open");
              }
            }
            if (index !== 2) return;
            // クラスのトグル
            if (header.classList.contains("open")) {
              setTimeout(() => {
                header.classList.toggle("open");
              }, 100);
            } else {
              setTimeout(() => {
                header.classList.toggle("open");
              }, 500);
            }
          },
        });

        // 2番目のアニメーションステップ
        addAnimation(
          tl,
          {
            targets: links,
            translateY: ["10px", 0],
            opacity: 1,
            easing: "easeInOutCubic",
            duration: 400,
            delay: (el, i) => -30 + 40 * i,
            complete: () => {
              if (index === 2) {
                hbg.classList.remove("operation");
              }
            },
          },
          "+=600",
        );
      });
    } else {
      if (header.classList.contains("open")) {
        uls.forEach((ul, index) => {
          const tl = anime.timeline({
            easing: "easeInOutCubic",
            duration: 300,
          });
          const links = ul.querySelectorAll("a");
          addAnimation(tl, {
            targets: links,
            translateY: [0, "10px"],
            opacity: 0,
            easing: "easeInOutCubic",
            duration: 400,
            delay: (el, i) => -30 + 40 * i,
            complete: () => {
              if (index === 2) {

                hbg.classList.remove("sub-menu-open");
                setTimeout(() => {
                  hbg.classList.remove("operation");
                  header.classList.remove("open");
                }, 800);
              }
            },
          });
        })
        setTimeout(() => {
          hbg.classList.toggle("sub-menu-open");

        }, 300);

        setTimeout(() => {
         header.classList.toggle("open");

        }, 800);

      } else {
        hbg.classList.toggle("sub-menu-open");
        header.classList.toggle("open");

        uls.forEach((ul, index) => {
          const tl = anime.timeline({
            easing: "easeInOutCubic",
            duration: 300,
          });
          const links = ul.querySelectorAll("a");
          // 最初のアニメーションステップ
          addAnimation(tl, {
            targets: links,
            translateY: ["10px", 0],
            opacity: 1,
            easing: "easeInOutCubic",
            duration: 400,
            delay: (el, i) => -30 + 40 * i,
            complete: () => {
              if (index === 2) {
                hbg.classList.remove("operation");
              }
            },
          });
        });
      }
    }
  }


  // ドキュメント全体でクリックイベントをデリゲート（.js-closeHbg用）
  document.addEventListener(
    "click",
    (e) => {

      const closeBtn = e.target.closest(".js-closeHbg");

      if (closeBtn) {
        if (!closeBtn.href.split("#")[1]) e.preventDefault();
        runAnimationProcess(hbg)
        setTimeout(() => {
          // hbg.classList.remove("sub-menu-open");
        }, 600);
      }
    },
    false,
  );
};



function slideInAnimationFunc() {
  const slideInElements = document.querySelectorAll(".js-slide-in");

  // 親要素ごとに .js-slide-in 要素をグループ化
  const groupedElements = {};

  slideInElements.forEach((el) => {
    const parent = el.parentElement;

    // 親要素に一意の識別子を設定
    const parentId = parent.dataset.groupId || `group-${Math.random().toString(36).substr(2, 9)}`;
    if (!parent.dataset.groupId) {
      parent.dataset.groupId = parentId;
    }

    // 親要素IDをキーとしてグループ化
    if (!groupedElements[parentId]) {
      groupedElements[parentId] = [];
    }
    groupedElements[parentId].push(el);
  });

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");

        const targets = entry.target.querySelectorAll(".letter");

        // 対象の親要素IDから、直下の .js-slide-in 要素の配列を取得
        const parentId = entry.target.parentElement.dataset.groupId;
        const siblings = groupedElements[parentId];
        const index = siblings.indexOf(entry.target); // 現在の要素のインデックス
        const baseDelay = 150; // 基本遅延時間
        const delayTime = baseDelay * index; // インデックスに基づく遅延

        if (entry.target.dataset.effect === "bottom" || entry.target.dataset.effect === "top") {
          anime.timeline().add({
            targets: entry.target,
            scaleY: 1,
            duration: 1800,
            easing: "easeOutExpo",
          });
        } else if (entry.target.dataset.effect === "up") {
          anime.timeline().add({
            targets: entry.target,
            translateY: 0,
            scaleY: 1,
            opacity: 1,
            easing: "easeOutExpo",
            duration: 1400,
            delay: delayTime,
          });
        } else {
          anime.timeline().add({
            targets: targets,
            translateY: 0,
            opacity: 1,
            easing: "easeOutExpo",
            duration: 1100,
            delay: (el, i) => delayTime + 30 * i,
          });
        }

        observer.unobserve(entry.target);
      }
    });
  };

  const observerOptions = {
    root: null,
    rootMargin: "-15% 15%",
    threshold: [0, 0.2, 0.3, 0.5, 1],
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // 各要素を初期化し、Observerを適用
  slideInElements.forEach(function (el) {
    if (el.dataset.effect === "bottom" || el.dataset.effect === "top") {
      anime.set(el, {
        scaleY: 0.1,
      });
    } else if (el.dataset.effect === "up") {
      anime.set(el, {
        opacity: 0,
        scaleY: 1.2,
        translateY: 20,
      });
    } else {
      el.innerHTML = el.innerHTML.replace(/(<[^>]+>)|(\S)/g, (match, tag, char) => {
        return tag ? tag : `<span class="letter">${char}</span>`;
      });

      anime.set(el.querySelectorAll("span"), {
        opacity: 0,
        translateY: 20,
      });
    }

    observer.observe(el);
  });
}

function scrollAnimation(elem, className) {
  const targets = document.querySelectorAll(elem);

  // Intersection Observerのコールバック関数
  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      anime({
        targets: entry.target.querySelectorAll("img"),
        translateY: 20,
        opacity: 0,
      });
      if (entry.isIntersecting) {
        entry.target.classList.add(className);
        anime({
          targets: entry.target.querySelectorAll("img"),
          translateY: [20, 0],
          opacity: [0, 1],
          easing: "cubicBezier(0.215, 0.61, 0.355, 1)",
          duration: 800,
          delay: anime.stagger(160),
          complete: () => {},
        });
        observer.unobserve(entry.target);
      }
    });
  };

  // Intersection Observerのオプション
  const observerOptions = {
    root: null, // ビューポートをルートとする
    rootMargin: "-15% -10%", // ビューポートの中心を判定基準にする
    threshold: [0, 0.5, 1], // 交差のしきい値
  };

  // Intersection Observerのインスタンスを作成
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  targets.forEach(function (target) {
    observer.observe(target);
  });
}


const arrowFunc = () => {
  const svgContent = `
      <svg width="45" height="16" viewBox="0 0 45 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M44.7071 8.70711C45.0976 8.31658 45.0976 7.68342 44.7071 7.29289L38.3431 0.928932C37.9526 0.538408 37.3195 0.538408 36.9289 0.928932C36.5384 1.31946 36.5384 1.95262 36.9289 2.34315L42.5858 8L36.9289 13.6569C36.5384 14.0474 36.5384 14.6805 36.9289 15.0711C37.3195 15.4616 37.9526 15.4616 38.3431 15.0711L44.7071 8.70711ZM0 9H44V7H0V9Z"
          fill="black" />
      </svg>
    `;

  // クラス 'btn-arrow' を持つすべての要素を取得
  const iconArrowElements = document.querySelectorAll(".btn-arrow");

  // 各要素にSVGを追加
  iconArrowElements.forEach((element) => {
    element.insertAdjacentHTML("beforeend", svgContent);
  });
}



// 対象の要素を取得
const targetElement = document.querySelector(".js-header-class");

if (targetElement) {
  // MutationObserverのコールバック関数
  const observerCallback = (mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        // js-header-classにsub-menu-openがある場合、bodyにopenを追加
        if (targetElement.classList.contains("sub-menu-open")) {
          document.body.classList.add("open2");
        } else {
          document.body.classList.remove("open2");
        }
      }
    });
  };

  // MutationObserverの設定
  const observer = new MutationObserver(observerCallback);

  // 対象の要素に対して監視を開始
  observer.observe(targetElement, { attributes: true });
}


let lastScrollTop = 0;

// Intersection Observer APIを使用して.kvが画面内に入った場合に処理を行う
const kvElement = document.querySelector(".kv");
if (kvElement) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.body.classList.add("inside-kv");
        } else {
          document.body.classList.remove("inside-kv");
        }
      });
    },
    {
      threshold: 0.1, // 要素の10%が見えるときにコールバック
    },
  );
  observer.observe(kvElement);
}

// スロットリング関数
function throttle(fn, limit) {
  let lastCall = 0;
  return function(...args) {
    const now = Date.now();
    if (now - lastCall >= limit) {
      lastCall = now;
      fn.apply(this, args);
    }
  };
}

const lenisFunc = () => {
  const lenis = new Lenis({
    smoothWheel: true,
    smoothTouch: true,
  });

  const backgroundElements = document.querySelectorAll(".background-image picture");

  // 各要素ごとに状態を管理するMap
  const elementStates = new Map();

  backgroundElements.forEach((element) => {
    elementStates.set(element, {
      isInView: false,
      baseScrollY: null,
    });
  });

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      const target = entry.target;
      const state = elementStates.get(target);
      if (!state) return;

      if (entry.isIntersecting) {
        state.isInView = true;
      } else {
        // スクロール位置リセット
        state.isInView = false;
        state.baseScrollY = null;
      }

      elementStates.set(target, state);
    });
  };

  const observerOptions = {
    root: null,
    threshold: 0,
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  backgroundElements.forEach((el) => observer.observe(el));

  // スクロールハンドラ
  const handleScroll = throttle((e) => {
    // 全ての要素に対して処理
    elementStates.forEach((state, element) => {
      if (!state.isInView) return;

      // 基準値が未設定なら現在位置をセット
      if (state.baseScrollY === null) {
        state.baseScrollY = e.scroll;
      }

      const flug = element.parentElement.classList.contains('is-3');
      const relativeScrollY = e.scroll - (flug ? 0 : state.baseScrollY);
      element.style.transform = `translateY(${flug ? relativeScrollY * 0.2 : -relativeScrollY * 0.1}px)`;
    });
  }, 10);

  lenis.on("scroll", handleScroll);
  lenis.start();

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
};

function clonePhotoList() {
  const photoList = document.querySelector(".sc-photo-list");
  if (!photoList) return;

  const originalUl = photoList.querySelector("ul");
  if (!originalUl) return

  const clonedUl = originalUl.cloneNode(true);
  photoList.appendChild(clonedUl);
  photoList.classList.remove("paused");
}





  // SimpleBarの初期化
const scrollableContainer = document.querySelector(".scrollable");
if (scrollableContainer) {
    new SimpleBar(scrollableContainer, {
      autoHide: false,
    });
}


let isOpen;

if (mq("pc")) {
  // スクロールイベントリスナー
  const threshold = 50; // どの程度スクロール量が変化したら反応するかのしきい値(任意調整)

  window.addEventListener("scroll", () => {
    window.requestAnimationFrame(() => {
      if (!isOpen) return;
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // 前回位置との差分を取得
      const scrollDiff = Math.abs(currentScrollTop - lastScrollTop);

      // しきい値より小さい場合は反応しない
      if (scrollDiff < threshold) {
        return;
      }

      if (isOpen.contains("sub-menu-open")) {
        if (currentScrollTop < lastScrollTop) {
          // 上にスクロールしているとき
          document.body.classList.add("open");
        }
      } else {
        if (currentScrollTop < lastScrollTop) {
          // 上にスクロールしているとき
          document.body.classList.add("open");
        } else {
          // 下にスクロールしているとき
          document.body.classList.remove("open");
        }
      }

      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Safariの負のスクロール値防止
    });
  });
}


const initializeGLightbox = () => {
  // すべてのギャラリー要素を取得
  const galleries = document.querySelectorAll(".sc-photoGallery-list");

  galleries.forEach((gallery, index) => {
    // 各ギャラリー内のすべての画像を取得
    const images = gallery.querySelectorAll("img");
    const lightboxClass = `lightbox-${index}`;

    // 各画像にユニークなクラスを追加
    images.forEach((img) => img.classList.add(lightboxClass));

    // GLightboxを初期化
    GLightbox({
      selector: `.${lightboxClass}`,
      touchNavigation: true,
      autoplayVideos: true,
      loop: true,
    });
  });
};

const lightboxInlineIframe = () => {
  GLightbox({
    selector: ".lightbox",
  });
}

// DOMが完全にロードされたらbodyに'open'クラスを追加
document.addEventListener("DOMContentLoaded", () => {
  console.log("DOMContentLoaded");
  if (BODY[0].classList.contains("open")) return;

  arrowFunc();
  calendarFunc("miyazaki");
  calendarFunc("chikugo");
  clonePhotoList();
  initializeGLightbox();
  slideInAnimationFunc();
  scrollAnimation(".js-about-ftan", "showing");
  splideFunc();
  lightboxInlineIframe();
  BODY[0].classList.add("open");
});

document.addEventListener("htmx:load", (event) => {
  const triggerElt = event.target.closest("[hx-get]");

  if (triggerElt) {
    const url = triggerElt.getAttribute("hx-get");
    const basePath = url.split("/")[0];

    // 共通処理を関数化
    const updateAttribute = (elements, attribute) => {
      elements.forEach((el) => {
        const attrValue = el.getAttribute(attribute);
        if (attrValue.startsWith("..")) {
          el.setAttribute(attribute, attrValue.replace("..", basePath));
        } else if (attrValue.startsWith("./")) {
          el.setAttribute(attribute, attrValue.replace("./", `${basePath}/`));
        }
      });
    };

    // img の src 属性を修正
    const images = event.target.querySelectorAll("img[src]");
    updateAttribute(images, "src");

    // a の href 属性を修正
    const links = event.target.querySelectorAll("a[href]");
    updateAttribute(links, "href");

    if (BODY[0].id) {
      links.forEach((el)=>{
        const adjustment = el.classList.contains(".js-adjustment");

        if (adjustment) {
          const attrValue = el.getAttribute(attribute);
          el.setAttribute("href", attrValue.replace("./", ""));
        }

      })
    }

  } else {
    console.log("hx-get を持つ要素が見つかりません");
  }

  if (triggerElt?.classList.contains("header")) {
    hbgFunc();
    isOpen = document.querySelector(".js-hbg").classList;
  }


  if (triggerElt?.classList.contains("footer")) {
    lenisFunc();
    accordionsFunc(document.querySelector(".sc-shuttlebus"));
    accordionsFunc(document.querySelector(".sc-map"));
    accordionsFunc(document.querySelector(".sc-app-point"));
    accordionsFunc(document.querySelector(".guide-section"));
  }



});


window.addEventListener("load", () => {

});
